import {IndexPageHeader} from '../components/IndexPageHeader';
import {AccountApplicationsGrid} from "../tables/AccountApplicationsGrid.tsx";
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    SimplePageContentWrapper,
    SimplePageLayout
} from "@flexinet/ui-components";

export const IndexPage = () => {


    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <AccountApplicationsGrid/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
